import { render, staticRenderFns } from "./BillingPage.vue?vue&type=template&id=47d23708&scoped=true&"
import script from "./BillingPage.vue?vue&type=script&lang=js&"
export * from "./BillingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d23708",
  null
  
)

export default component.exports